import MonthlySummaryError from './MonthlySummaryError';
class MonthlySummaryCouponNotFound extends MonthlySummaryError {
    promotionalCouponId;
    constructor(promotionalCouponId, options) {
        super('Promotional coupon id not found', options);
        this.promotionalCouponId = promotionalCouponId;
    }
}
export default MonthlySummaryCouponNotFound;
